<template>
  <div>
    <div v-if="icore == false" class="skin-blue fixed-layout">
      <uHeader v-show="true" />
      <sidebar v-show="true" />
      <router-view style="min-height: 100vh" />
      <Ufooter v-show="icore == false" />
    </div>
    <div v-else-if="icore === 'payment'" class="skin-blue fixed-layout">
      <router-view />
    </div>
    <div v-else-if="icore === 'lockscreen'" class="skin-blue fixed-layout">
      <lockscreen />
    </div>
    <div v-else-if="icore == 'CheckIn'" class="skin-blue fixed-layout">
      <CheckIn />
    </div>
    <!-------------Chat box--------------------->
    <UserChatPopUp v-if="this.chatUrl !== '/userChat'" />
  </div>
</template>

<script>
import uHeader from "./components/UHeader.vue";
import sidebar from "./components/sidebar.vue";
import Ufooter from "./components/Footer.vue";
import lockscreen from "./views/lockscreen.vue";
import UserChatPopUp from "./components/UserChatPopUp.vue";
import CheckIn from "./views/CheckIn.vue";
import axios from "axios";
import { mapGetters } from "vuex";
import { createToast } from "mosha-vue-toastify";
import "mosha-vue-toastify/dist/style.css";
//firebase
import { initializeApp } from "firebase/app";
import {
  getMessaging,
  getToken,
  onMessage,
  onBackgroundMessage,
} from "firebase/messaging";

export default {
  data() {
    return {
      myPages: false,
      subscriptionData: null,
      headerDisplay: this.$store.getters.getheaderDisplay,
      sidebarDisplay: this.$store.getters.getsidebarDisplay,
      NotificationIds: [],
      token: "",
    };
  },
  //components: { CheckIn },
  components: { Ufooter, uHeader, sidebar, lockscreen, CheckIn, UserChatPopUp },
  //components: { Ufooter, UHeader, sidebar },

  beforeCreate() {
    if (localStorage.icore != "lockscreen") {
      if (window.location.search) {
        localStorage.clear();
      }
    }
    if (typeof localStorage.icore === "undefined") localStorage.icore = "point";
    var str = "";
    if (
      localStorage.OSversion == undefined ||
      localStorage.OSversion === "null"
    ) {
      str = window.location.search.slice(7);
      localStorage.xeon = str.split("area=")[1];

      str = str.slice(0, -7);
      let xyz = str.split("%3CVEINS2021/%3E");
      let abc = "";
      for (let i = 0; i < xyz.length; i++) {
        abc += xyz[i];
        if (i < xyz.length - 1) {
          abc += "<VEINS2021/>";
        }
      }
      localStorage.OSversion = abc;
      this.$store.dispatch("setNewlocalStorage", abc);
      this.$store.dispatch("setNewlocalStorageXeon", localStorage.xeon);
    } else {
      this.$store.dispatch("setNewlocalStorage", localStorage.OSversion);
      this.$store.dispatch("setNewlocalStorageXeon", localStorage.xeon);
    }
    //localStorage.cando = "";
    // else localStorage.icore = "";
  },

  methods: {
    axiosGetAuthToken() {
      const str = localStorage.OSversion;
      const Url =
        this.SERVER + "/VNSPRAAPI/Accounts/AuthenticateToken?token=" + str;
      return axios({
        method: "get",
        url: Url,
      })
        .then((res) => {
          const myData = res.data;
          if (myData.status == true) {
            this.$store.commit("setAuthToken", myData.token);
            this.$store.commit("setAuthTokenOnly", myData.token);
            localStorage.BeToken = myData.token;
          } else {
            if (myData.error == true) {
              this.AutoLogout();
            }
          }
        })
        .catch(function(error) {
          alert(console.log(error));
        })
        .finally(() => {
          this.axiosGetInitialLoad();
          this.myPages = true;
        });
    },
    async axiosSaveToken() {
      this.intDummyComm();
      this.dummyComm.extras2 = this.token;
      const url = this.SERVER + `/VNSPRAAPI/Practices/SaveToken`;
      axios({
        method: "post",
        url: url,
        data: this.dummyComm,
      }).then((res) => {
        if (res.data.userLoggedIn == 0) {
          this.logoutClick_1();
          return;
        }
        if (res.status === 200) {
          console.log("Token added");
        } else {
          localStorage.cando = "err";
          this.$store.dispatch("setNewlocalStorageCando", localStorage.cando);
        }
      });
    },
    async axiosGetInitialLoad() {
      this.intDummyComm();
      const url = this.SERVER + `/VNSPRAAPI/Practices/InitialLoad`;
      axios({
        method: "post",
        url: url,
        data: this.dummyComm,
      })
        .then((res) => {
          if (res.data.userLoggedIn == 0) {
            this.logoutClick_1();
            return;
          }
          if (res.status === 200) {
            //debugger;;
            this.subscriptionData = JSON.parse(res.data.subcriptionRigths);
            let str = ":";
            str += "a1" + this.subscriptionData.CanPatients + ":";
            str += "b1" + this.subscriptionData.CanUsers + ":";
            str += "c1" + this.subscriptionData.CanPractices + ":";
            str += "d1" + this.subscriptionData.CanVeinsCheckIn + ":";
            str += "e1" + this.subscriptionData.CanVisitTracker + ":";
            str += "f1" + this.subscriptionData.CanPayments + ":";
            str += "g1" + this.subscriptionData.CanEmail + ":";
            str += "h1" + this.subscriptionData.CanSms + ":";
            str += ":";
            if (localStorage.cando !== str && localStorage.cando == undefined) {
              localStorage.cando = str;
              this.$store.dispatch("setNewlocalStorageCando", str);
              // this.$router.push({ path: '/StageDisplay'});
            }
          } else {
            localStorage.cando = "err";
            this.$store.dispatch("setNewlocalStorageCando", localStorage.cando);
          }
        })
        .finally(() => {
          // this.axiosGetAuthToken();
          console.log(this.$router.currentRoute.value.path);
          if (this.$router.currentRoute.value.path == "/") {
            this.$router.push({ path: "/StageDisplay" });
          }
        });
    },
    async axiosCreated() {
      // get user loggedin
      this.intDummyComm();
      const url = this.SERVER + `/VNSPRAAPI/Practices/IsUserLoggedIn`;
      axios({
        method: "post",
        url: url,
        data: this.dummyComm,
      }).then((res) => {
        if (res.data == 0) {
          this.logoutClick_1();
        }
        //else if (res.data * 1 < 1) window.history.back();
        this.axiosGetData();
      });
    },

    async axiosGetData() {
      // get plans details
      //debugger;;// eslint-disable-line no-//debugger;
      const myUrl = this.SERVER + "/VNSPRAAPI/Practices/GetOwnerPlanDetails";
      this.intDummyComm();
      await axios({
        method: "post",
        url: myUrl,
        data: this.dummyComm,
      })
        .then((res) => {
          //debugger

          if (res.status === 200) {
            this.subscriptionData = res.data;
            let str = ":";
            str += "a1" + res.data.CanPatients + ":";
            str += "b1" + res.data.CanUsers + ":";
            str += "c1" + res.data.CanPractices + ":";
            str += "d1" + res.data.CanVeinsCheckIn + ":";
            str += "e1" + res.data.CanVisitTracker + ":";
            str += "f1" + res.data.CanPayments + ":";
            str += "g1" + res.data.CanEmail + ":";
            str += "h1" + res.data.CanSms + ":";
            str += ":";

            localStorage.cando = str;
            this.$store.dispatch("setNewlocalStorageCando", str);
            //this.$router.push({ path: '/StageDisplay'});
          } else {
            localStorage.cando = "err";
            this.$store.dispatch("setNewlocalStorageCando", localStorage.cando);
          }
        })
        .catch(function(error) {
          if (error.response) {
            this.lastErrorCode = 1;
            alert("-> " + error.response.data);
            alert("-> " + error.response.status);
            alert("-> " + error.response.headers);
          } else if (error.request) {
            this.lastErrorCode = 1;
            alert("No response " + error.request);
          } else {
            this.lastErrorCode = 1;
            //alert("Error", error.message);
          }
        })
        .finally(() => {});
    }, //axiosGetData
    GetToken() {
      const firebaseConfig = {
        apiKey: "AIzaSyANJtW9d3QOUSJiHRz7odc7ny1ArEg5u3k",
        authDomain: "veins-practice-solution.firebaseapp.com",
        projectId: "veins-practice-solution",
        storageBucket: "veins-practice-solution.appspot.com",
        messagingSenderId: "995802628788",
        appId: "1:995802628788:web:6b3f58ddad6ae45c4fcde1",
        measurementId: "G-E09KBYJ6HW",
      };

      //application initialzed app
      const app = initializeApp(firebaseConfig);
      const messaging = getMessaging(app);

      getToken(messaging, {
        vapidKey:
          "BN-c2gwNN4ixedq8HTZZRNbAKCY9augWtPm-8M3U4Hq1amXlGQ7uS2CJ3kUTN7G5PIKuHHtMcl3aFlVDUtgomYE",
      })
        .then((currentToken) => {
          if (currentToken) {
            this.token = currentToken;
            this.axiosSaveToken();

            onMessage(messaging, (payload) => {
              if (!document.hidden) {
                const title = payload.notification.title;
                const options = {
                  body: payload.notification.body,
                  icon:
                    "https://veinsdev.blob.core.windows.net/mylogos/veinicon.jpeg",
                };
                if (payload.data.notification_type === "stageDisplay_message") {
                  new Notification(title, options).onclick = function(event) {
                    event.preventDefault(); // prevent the browser from focusing the Notification's tab
                    window.open("/StageDisplay", "_blank");
                  };
                } else if (payload.data.notification_type === "chat_message") {
                  createToast(
                    {
                      title: title,
                      description: options.body,
                    },
                    {
                      type: "info",
                      transition: "slide",
                      timeout: 2500,
                    }
                  );
                } else {
                  new Notification(title, options).onclick = function(event) {
                    event.preventDefault(); // prevent the browser from focusing the Notification's tab
                    window.open(payload.data.screenURL.toString(), "_blank");
                  };
                }
              }
            });
          } else {
            // Show permission request UI
            console.log(
              "No registration token available. Request permission to generate one."
            );
            // ...
          }
        })
        .catch((err) => {
          console.log("An error occurred while retrieving token. ", err);
          // ...
        });
    },
  },
  created() {
    //get token for firebase
    this.GetToken();
    this.axiosGetAuthToken();
    // this.axiosGetInitialLoad();
  },

  mounted() {
    this.intDummyComm();

    //this.axiosGetAuthToken();
  },

  computed: {
    ...mapGetters([
      "getProfileImage",
      "geterLocalStorage",
      "getLocalStoragecando",
      "getLocalStoragexeon",
    ]),
    icore() {
      //alert(localStorage.icore + " >>>> icore");
      if (localStorage.icore == "point" || localStorage.icore == "") {
        return localStorage.icore === "" ? true : false; //What is this ? if icore i ever true you cant see anything :P
      } else if (localStorage.icore == "CheckIn") {
        return (localStorage.icore = "CheckIn");
      } else if (localStorage.icore == "payment") {
        return (localStorage.icore = "payment");
      } else {
        return (localStorage.icore = "lockscreen");
      }
    },
  },
};
</script>

<style lang="scss"></style>
